import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { useNavigate } from "react-router-dom-v5-compat";

interface UseDataTableRoutingProps {
  tenantKey: string;
  projectKey: string;
}

/** Hook that returns a function for navigating to data table routes */
export const useDataTableRouting = ({
  tenantKey,
  projectKey,
}: UseDataTableRoutingProps) => {
  const navigate = useNavigate();
  return useRouteMapContext(
    (s) => {
      return (tableKey: string | undefined) => {
        const path =
          tableKey === undefined
            ? s.routeMap.PROJECT.dynamicPath({ tenantKey, projectKey }).path
            : s.routeMap.PROJECT_TABLE.dynamicPath({
                tenantKey,
                projectKey,
                tableKey,
              }).path;
        navigate(path);
      };
    },
    () => true,
  );
};
